import { database, storage } from './config'
// import firebase from 'firebase/app'
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Producto {
    constructor() {
        this.Activo = true
        this.Oferta = false
        this.Categoria = ''
        this.Descripcion = ''
        this.Detalle = ''
        this.Img = ''
    }

    guardar(producto) {
        // this.db.collection('post').doc('key').set({})
        if(producto.id) return this.editar(producto)
        return database.collection('productos').doc().set({
            ...producto,
            Fecha: new Date(),
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

    editar(producto) {
        return database.collection('productos').doc(producto.id).update({
            ...producto,
            Fecha: new Date(),
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

    eliminar(id) {
        return new Promise((resolve, reject) => {
            database.collection("productos")
                .doc(id)
                .delete()
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    subirImagenProducto(file, descripcion, actualizarImgProgress, getImgUrl) {
        const refStorage = storage.ref(`ImgProductos/${descripcion}`)
        const task = refStorage.put(file)
        task.on('state_changed',
            snapshot => {
                const porcentaje = snapshot.bytesTransferred / snapshot.totalBytes * 100
                actualizarImgProgress(porcentaje)
            },
            err => {
                console.error(err.message)
            },
            () => {
                task.snapshot.ref.getDownloadURL()
                    .then(url => {
                        console.log(url)
                        sessionStorage.setItem('imgNewProducto', url)
                        getImgUrl(url)
                    })
                    .catch(err => console.error(err.message))
            })
    }


    leerProductosCategoria(categoria) {
        return new Promise((resolve, reject) => {
            database.collection('productos')
                .where('Categoria', '==', categoria)
                .where('Activo', '==', true)
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerProductos() {
        return new Promise((resolve, reject) => {
            database.collection('productos')
                .where('Activo', '==', true)
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerProductosAdmin() {
        return new Promise((resolve, reject) => {
            database.collection('productos')
                .orderBy('Img', 'desc')
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerProductosOferta() {
        return new Promise((resolve, reject) => {
            database.collection('productos')
                .where('Oferta', '==', true)
                .where('Activo', '==', true)
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    leerProducto(id) {
        return new Promise((resolve, reject) => {
            database.collection('productos')
                .doc(id)
                .get()
                .then(doc => resolve(doc.data()))
                .catch(error => reject(Error.guardarError(error)))
        })
    }


}